import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const MonteurProfiel = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { gebruiker: huidigeGebruiker } = useAuth();
  const [gebruiker, setGebruiker] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState('');
  const [ploegen, setPloegen] = useState([]);
  const [cursussen, setCursussen] = useState([]);
  const [showCursusModal, setShowCursusModal] = useState(false);
  const [editCursus, setEditCursus] = useState(null);
  const [nieuweCursus, setNieuweCursus] = useState({ naam: '', uitgever: '', behaald_op: '', verloopt_op: '', gepland_op: '', certificaat_nummer: '', notities: '' });
  const [cursusBestand, setCursusBestand] = useState(null);
  const [afw, setAfw] = useState({ soort: 'verlof', start: '', eind: '', dagdeel: 'hele_dag', uren: '', type_verlof: 'Vakantie', opmerking: '', mail_monteur: true, kopie_kantoor: false });
  const [afwSaving, setAfwSaving] = useState(false);
  const [afwMsg, setAfwMsg] = useState('');
  const [roosterVrij, setRoosterVrij] = useState([]);
  const [nieuwRV, setNieuwRV] = useState({ dag_van_week: 3, frequentie: 'wekelijks', vanaf_datum: new Date().toISOString().slice(0,10) });
  const verstuurAfwezigheid = async () => {
    if (!afw.start) { setAfwMsg('Fout: startdatum verplicht'); return; }
    setAfwSaving(true); setAfwMsg('');
    try {
      const body = { voor_gebruiker_id: gebruiker.id, soort: afw.soort, start: afw.start, eind: afw.eind || afw.start, dagdeel: afw.dagdeel };
      if (afw.uren) body.uren = parseFloat(afw.uren);
      if (afw.opmerking) body.opmerking = afw.opmerking;
      if (afw.soort === 'verlof') body.type_verlof = afw.type_verlof;
      body.mail_monteur = afw.mail_monteur;
      body.kopie_kantoor = afw.kopie_kantoor;
      const res = await api.post('/formulier-invullingen/kantoor-afwezigheid', body);
      const d = res.data || {};
      setAfwMsg('Ingepland (' + (d.planning_dagen || 0) + ' dag(en))');
      setAfw({ soort: 'verlof', start: '', eind: '', dagdeel: 'hele_dag', uren: '', type_verlof: 'Vakantie', opmerking: '' });
    } catch (e) {
      setAfwMsg('Fout: ' + ((e.response && e.response.data && e.response.data.message) || e.message));
    } finally { setAfwSaving(false); }
  };

  const isWerkvoorbereider = huidigeGebruiker?.rol === 'werkvoorbereider' || huidigeGebruiker?.rol === 'bedrijf_admin' || huidigeGebruiker?.rol === 'super_admin';

  useEffect(() => { loadData(); }, [id]);

  const loadData = async () => {
    try {
      const [userRes, ploegenRes, cursussenRes] = await Promise.all([
        api.get('/gebruikers/' + id),
        api.get('/ploegen'),
        api.get('/cursussen/gebruiker/' + id)
      ]);
      setGebruiker(userRes.data.data || userRes.data);
      setPloegen(ploegenRes.data.data || []);
      setCursussen(cursussenRes.data.data || []);
      try { const rvRes = await api.get('/rooster-vrij?gebruiker_id=' + id); setRoosterVrij(rvRes.data.data || []); } catch (e) { /* rooster-vrij optioneel */ }
      setLoading(false);
    } catch (err) {
      console.error('Fout laden profiel:', err);
      setLoading(false);
    }
  };

  const handleChange = (key, value) => {
    setGebruiker(prev => ({ ...prev, [key]: value }));
  };

  const saveProfiel = async () => {
    setSaving(true);
    setSaveMsg('');
    try {
      await api.put('/gebruikers/' + id + '/profiel', {
        telefoon: gebruiker.telefoon,
        adres: gebruiker.adres,
        geboortedatum: gebruiker.geboortedatum,
        in_dienst_sinds: gebruiker.in_dienst_sinds,
        functie: gebruiker.functie,
        nood_contact_naam: gebruiker.nood_contact_naam,
        nood_contact_telefoon: gebruiker.nood_contact_telefoon,
        nood_contact_relatie: gebruiker.nood_contact_relatie,
        ploeg_id: gebruiker.ploeg_id,
        nachtdienst_start: gebruiker.nachtdienst_start,
        nachtdienst_interval_weken: gebruiker.nachtdienst_interval_weken,
        storingsdienst_start: gebruiker.storingsdienst_start,
        storingsdienst_interval_weken: gebruiker.storingsdienst_interval_weken
      });
      setSaveMsg('Opgeslagen!');
      setTimeout(() => setSaveMsg(''), 3000);
    } catch (err) {
      setSaveMsg('Fout bij opslaan');
    }
    setSaving(false);
  };

  const addCursus = async () => {
    if (!nieuweCursus.naam) { alert('Naam is verplicht'); return; }
    try {
      const res = await api.post('/cursussen', { ...nieuweCursus, gebruiker_id: id });
      const newId = res.data && res.data.data && res.data.data.id;
      if (cursusBestand && newId) {
        const fd = new FormData();
        fd.append('bestand', cursusBestand);
        await api.post('/cursussen/' + newId + '/bestand', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      }
      setNieuweCursus({ naam: '', uitgever: '', behaald_op: '', verloopt_op: '', gepland_op: '', certificaat_nummer: '', notities: '' });
      setCursusBestand(null);
      setShowCursusModal(false);
      loadData();
    } catch (err) { alert('Fout bij toevoegen'); }
  };

  const updateCursus = async () => {
    if (!editCursus) return;
    try {
      await api.put('/cursussen/' + editCursus.id, editCursus);
      setEditCursus(null);
      loadData();
    } catch (err) { alert('Fout bij opslaan'); }
  };

  const deleteCursus = async (cursusId) => {
    if (!window.confirm('Certificaat verwijderen?')) return;
    try {
      await api.delete('/cursussen/' + cursusId);
      loadData();
    } catch (err) { alert('Fout bij verwijderen'); }
  };

  const downloadCursusBestand = async (cursusId, naam) => {
    const token = localStorage.getItem('token');
    const r = await fetch('/api/cursussen/' + cursusId + '/bestand', { headers: { Authorization: 'Bearer ' + token } });
    if (!r.ok) return alert('Geen bestand of download mislukt');
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = (naam || 'certificaat') + '.pdf'; a.click();
    URL.revokeObjectURL(url);
  };

  const getCursusStatus = (verloopt_op) => {
    if (!verloopt_op) return 'geldig';
    const nu = new Date();
    const verloop = new Date(verloopt_op);
    const diffDagen = Math.ceil((verloop - nu) / (1000 * 60 * 60 * 24));
    if (diffDagen < 0) return 'verlopen';
    if (diffDagen < 60) return 'bijna';
    return 'geldig';
  };

  const getNachtdienstWeek = () => {
    if (!gebruiker?.nachtdienst_start || !gebruiker?.nachtdienst_interval_weken) return null;
    const start = new Date(gebruiker.nachtdienst_start);
    const nu = new Date();
    const diffWeken = Math.floor((nu - start) / (7 * 24 * 60 * 60 * 1000));
    const weekInCyclus = diffWeken % gebruiker.nachtdienst_interval_weken;
    return weekInCyclus === 0;
  };

  const getStoringsdienstWeek = () => {
    if (!gebruiker?.storingsdienst_start || !gebruiker?.storingsdienst_interval_weken) return null;
    const start = new Date(gebruiker.storingsdienst_start);
    const nu = new Date();
    const diffWeken = Math.floor((nu - start) / (7 * 24 * 60 * 60 * 1000));
    const weekInCyclus = diffWeken % gebruiker.storingsdienst_interval_weken;
    return weekInCyclus === 0;
  };

  const inputStyle = { width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '13px', color: '#6b7280', marginBottom: '4px', fontWeight: '500' };
  const laadRoosterVrij = async () => {
    try { const r = await api.get('/rooster-vrij?gebruiker_id=' + id); setRoosterVrij(r.data.data || []); } catch (e) {}
  };
  const voegRVToe = async () => {
    try {
      await api.post('/rooster-vrij', { gebruiker_id: parseInt(id), dag_van_week: nieuwRV.dag_van_week, frequentie: nieuwRV.frequentie, vanaf_datum: nieuwRV.vanaf_datum });
      await laadRoosterVrij();
    } catch (e) { alert('Kon rooster-vrije dag niet opslaan'); }
  };
  const verwijderRV = async (rvId) => {
    try { await api.delete('/rooster-vrij/' + rvId); await laadRoosterVrij(); } catch (e) { alert('Kon niet verwijderen'); }
  };
  const RV_DAGEN = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];

  const cardStyle = { background: 'white', borderRadius: '8px', padding: '20px', border: '1px solid #e5e7eb', marginBottom: '16px' };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Laden...</div>;
  if (!gebruiker) return <div style={{ padding: '40px', textAlign: 'center' }}>Gebruiker niet gevonden</div>;

  const heeftNachtdienst = getNachtdienstWeek();
  const heeftStoringsdienst = getStoringsdienstWeek();
  const ploegNaam = ploegen.find(p => p.id === gebruiker.ploeg_id)?.naam;

  return (
    <div>
      <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button onClick={() => navigate('/gebruikers')} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>←</button>
          <h1>👤 {gebruiker.voornaam} {gebruiker.achternaam}</h1>
          {ploegNaam && <span style={{ padding: '4px 12px', background: '#eef2ff', color: '#4338ca', borderRadius: '12px', fontSize: '13px', fontWeight: '500' }}>{ploegNaam}</span>}
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          {heeftNachtdienst === true && <span style={{ padding: '4px 12px', background: '#312e81', color: 'white', borderRadius: '12px', fontSize: '13px' }}>🌙 Nachtdienst deze week</span>}
          {heeftStoringsdienst === true && <span style={{ padding: '4px 12px', background: '#dc2626', color: 'white', borderRadius: '12px', fontSize: '13px' }}>🔴 Storingsdienst deze week</span>}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        {/* Persoonlijke info */}
        <div style={cardStyle}>
          <h2 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>📋 Persoonlijke Gegevens</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <div>
              <label style={labelStyle}>Voornaam</label>
              <input type="text" value={gebruiker.voornaam || ''} disabled style={{ ...inputStyle, background: '#f9fafb' }} />
            </div>
            <div>
              <label style={labelStyle}>Achternaam</label>
              <input type="text" value={gebruiker.achternaam || ''} disabled style={{ ...inputStyle, background: '#f9fafb' }} />
            </div>
            <div>
              <label style={labelStyle}>Email</label>
              <input type="text" value={gebruiker.email || ''} disabled style={{ ...inputStyle, background: '#f9fafb' }} />
            </div>
            <div>
              <label style={labelStyle}>Functie</label>
              <input type="text" value={gebruiker.functie || ''} onChange={e => handleChange('functie', e.target.value)} disabled={!isWerkvoorbereider} placeholder="bijv. 1e Monteur" style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Telefoon</label>
              <input type="text" value={gebruiker.telefoon || ''} onChange={e => handleChange('telefoon', e.target.value)} disabled={false} placeholder="06-12345678" style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Geboortedatum</label>
              <input type="date" value={gebruiker.geboortedatum ? gebruiker.geboortedatum.split('T')[0] : ''} onChange={e => handleChange('geboortedatum', e.target.value)} disabled={false} style={inputStyle} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Adres</label>
              <input type="text" value={gebruiker.adres || ''} onChange={e => handleChange('adres', e.target.value)} disabled={false} placeholder="Straat 1, 1234 AB Stad" style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>In dienst sinds</label>
              <input type="date" value={gebruiker.in_dienst_sinds ? gebruiker.in_dienst_sinds.split('T')[0] : ''} onChange={e => handleChange('in_dienst_sinds', e.target.value)} disabled={!isWerkvoorbereider} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Rol</label>
              <input type="text" value={gebruiker.rol || gebruiker.rol_naam || ''} disabled style={{ ...inputStyle, background: '#f9fafb' }} />
            </div>
          </div>
        </div>

        {/* Noodcontact */}
        <div style={cardStyle}>
          <h2 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>🆘 Noodcontact</h2>
          <div style={{ display: 'grid', gap: '12px' }}>
            <div>
              <label style={labelStyle}>Naam</label>
              <input type="text" value={gebruiker.nood_contact_naam || ''} onChange={e => handleChange('nood_contact_naam', e.target.value)} disabled={false} placeholder="Naam noodcontact" style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Telefoon</label>
              <input type="text" value={gebruiker.nood_contact_telefoon || ''} onChange={e => handleChange('nood_contact_telefoon', e.target.value)} disabled={false} placeholder="06-12345678" style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Relatie</label>
              <input type="text" value={gebruiker.nood_contact_relatie || ''} onChange={e => handleChange('nood_contact_relatie', e.target.value)} disabled={false} placeholder="bijv. Partner, ouder" style={inputStyle} />
            </div>
          </div>

          <h2 style={{ fontSize: '16px', fontWeight: '600', marginTop: '24px', marginBottom: '16px' }}>👥 Ploeg & Diensten</h2>
          <div style={{ display: 'grid', gap: '12px' }}>
            <div>
              <label style={labelStyle}>Ploeg</label>
              <select value={gebruiker.ploeg_id || ''} onChange={e => handleChange('ploeg_id', e.target.value ? parseInt(e.target.value) : null)} disabled={!isWerkvoorbereider} style={inputStyle}>
                <option value="">Geen ploeg</option>
                {ploegen.map(p => <option key={p.id} value={p.id}>{p.naam}</option>)}
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div>
                <label style={labelStyle}>🌙 Nachtdienst start</label>
                <input type="date" value={gebruiker.nachtdienst_start ? gebruiker.nachtdienst_start.split('T')[0] : ''} onChange={e => handleChange('nachtdienst_start', e.target.value)} disabled={!isWerkvoorbereider} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Interval (weken)</label>
                <input type="number" min="0" value={gebruiker.nachtdienst_interval_weken || 0} onChange={e => handleChange('nachtdienst_interval_weken', parseInt(e.target.value) || 0)} disabled={!isWerkvoorbereider} style={inputStyle} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div>
                <label style={labelStyle}>🔴 Storingsdienst start</label>
                <input type="date" value={gebruiker.storingsdienst_start ? gebruiker.storingsdienst_start.split('T')[0] : ''} onChange={e => handleChange('storingsdienst_start', e.target.value)} disabled={!isWerkvoorbereider} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Interval (weken)</label>
                <input type="number" min="0" value={gebruiker.storingsdienst_interval_weken || 0} onChange={e => handleChange('storingsdienst_interval_weken', parseInt(e.target.value) || 0)} disabled={!isWerkvoorbereider} style={inputStyle} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Opslaan knop */}
      {isWerkvoorbereider && (
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '16px' }}>
          <button onClick={saveProfiel} disabled={saving} style={{ padding: '10px 24px', borderRadius: '8px', border: 'none', background: '#3b82f6', color: 'white', cursor: 'pointer', fontWeight: '500', fontSize: '14px' }}>{saving ? '⏳ Opslaan...' : '💾 Profiel Opslaan'}</button>
          {saveMsg && <span style={{ color: saveMsg.includes('Fout') ? '#dc2626' : '#10b981', fontWeight: '500' }}>{saveMsg}</span>}
        </div>
      )}

      {/* Verlof en Ziek (kantoor) */}
      {isWerkvoorbereider && (
        <div style={cardStyle}>
          <h2 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>🗓️ Verlof &amp; Ziek inplannen</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px', alignItems: 'end' }}>
            <div>
              <label style={labelStyle}>Soort</label>
              <select value={afw.soort} onChange={e => setAfw({ ...afw, soort: e.target.value })} style={inputStyle}>
                <option value="verlof">Verlof</option>
                <option value="ziek">Ziek</option>
              </select>
            </div>
            {afw.soort === 'verlof' && (
              <div>
                <label style={labelStyle}>Type verlof</label>
                <select value={afw.type_verlof} onChange={e => setAfw({ ...afw, type_verlof: e.target.value })} style={inputStyle}>
                  <option>Vakantie</option>
                  <option>Bijzonder verlof</option>
                  <option>Onbetaald verlof</option>
                </select>
              </div>
            )}
            <div>
              <label style={labelStyle}>Van</label>
              <input type="date" value={afw.start} onChange={e => setAfw({ ...afw, start: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Tot en met</label>
              <input type="date" value={afw.eind} onChange={e => setAfw({ ...afw, eind: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Dagdeel</label>
              <select value={afw.dagdeel} onChange={e => setAfw({ ...afw, dagdeel: e.target.value })} style={inputStyle}>
                <option value="hele_dag">Hele dag</option>
                <option value="ochtend">Ochtend</option>
                <option value="middag">Middag</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Uren/dag (optioneel)</label>
              <input type="number" min="0" max="24" step="0.5" placeholder={afw.dagdeel === 'hele_dag' ? '8' : '4'} value={afw.uren} onChange={e => setAfw({ ...afw, uren: e.target.value })} style={inputStyle} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Opmerking</label>
              <input type="text" value={afw.opmerking} onChange={e => setAfw({ ...afw, opmerking: e.target.value })} placeholder="optioneel" style={inputStyle} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '18px', alignItems: 'center', marginTop: '12px', fontSize: '13px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
              <input type="checkbox" checked={afw.mail_monteur} onChange={e => setAfw({ ...afw, mail_monteur: e.target.checked })} />
              Monteur mailen
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
              <input type="checkbox" checked={afw.kopie_kantoor} onChange={e => setAfw({ ...afw, kopie_kantoor: e.target.checked })} />
              Mij kopie mailen
            </label>
          </div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '14px' }}>
            <button onClick={verstuurAfwezigheid} disabled={afwSaving} style={{ padding: '10px 24px', borderRadius: '8px', border: 'none', background: '#3b82f6', color: 'white', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>{afwSaving ? 'Inplannen...' : 'In planning zetten'}</button>
            {afwMsg && <span style={{ color: afwMsg.indexOf('Fout') === 0 ? '#dc2626' : '#10b981', fontWeight: '500' }}>{afwMsg}</span>}
          </div>
          <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '10px' }}>Zet het direct in de planning (geen SAP nodig). Die dag(del)en zijn daarna niet meer inplanbaar.</p>
        </div>
      )}

      {/* Rooster-vrije dagen */}
      <div style={cardStyle}>
        <h3 style={{ marginTop: 0, fontSize: '17px', display: 'flex', alignItems: 'center', gap: '8px' }}>{'🗓️'} Rooster-vrije dagen</h3>
        <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '14px' }}>Vaste vrije dag(en) in het rooster. Verschijnt in de planning; monteurs tellen die dag niet mee in de bezetting.</p>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: '14px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Dag</label>
            <select value={nieuwRV.dag_van_week} onChange={e => setNieuwRV({ ...nieuwRV, dag_van_week: parseInt(e.target.value, 10) })} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px' }}>
              {[1,2,3,4,5,6,0].map(d => <option key={d} value={d}>{RV_DAGEN[d]}</option>)}
            </select>
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Frequentie</label>
            <select value={nieuwRV.frequentie} onChange={e => setNieuwRV({ ...nieuwRV, frequentie: e.target.value })} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px' }}>
              <option value="wekelijks">Elke week</option>
              <option value="om_de_week">Om de week</option>
            </select>
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Vanaf</label>
            <input type="date" value={nieuwRV.vanaf_datum} onChange={e => setNieuwRV({ ...nieuwRV, vanaf_datum: e.target.value })} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px' }} />
          </div>
          <button onClick={voegRVToe} style={{ padding: '9px 18px', borderRadius: '8px', border: 'none', background: '#3b82f6', color: 'white', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>+ Toevoegen</button>
        </div>
        {roosterVrij.length === 0 ? (
          <p style={{ fontSize: '13px', color: '#9ca3af' }}>Nog geen rooster-vrije dagen ingesteld.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {roosterVrij.map(rv => (
              <div key={rv.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#f9fafb', borderRadius: '6px', border: '1px solid #e5e7eb' }}>
                <span style={{ fontSize: '14px' }}><strong>{RV_DAGEN[rv.dag_van_week]}</strong> {'·'} {rv.frequentie === 'om_de_week' ? 'om de week' : 'elke week'} {'·'} vanaf {rv.vanaf_datum ? new Date(rv.vanaf_datum).toLocaleDateString('nl-NL') : ''}</span>
                <button onClick={() => verwijderRV(rv.id)} style={{ border: 'none', background: 'transparent', color: '#ef4444', cursor: 'pointer', fontSize: '18px' }} title="Verwijderen">{'🗑'}</button>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* Certificaten */}
      <div style={cardStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>🎓 Certificaten & Opleidingen</h2>
          {isWerkvoorbereider && (
            <button onClick={() => setShowCursusModal(true)} style={{ padding: '6px 14px', borderRadius: '6px', border: 'none', background: '#3b82f6', color: 'white', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>+ Toevoegen</button>
          )}
        </div>

        {cursussen.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#9ca3af', padding: '20px' }}>Nog geen certificaten</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {cursussen.map(c => {
              const status = getCursusStatus(c.verloopt_op);
              const statusKleur = status === 'verlopen' ? '#dc2626' : status === 'bijna' ? '#f59e0b' : '#10b981';
              const statusBg = status === 'verlopen' ? '#fef2f2' : status === 'bijna' ? '#fffbeb' : '#f0fdf4';
              const statusTekst = status === 'verlopen' ? 'Verlopen' : status === 'bijna' ? 'Verloopt binnenkort' : 'Geldig';
              return (
                <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', background: '#f9fafb', borderRadius: '8px', borderLeft: '4px solid ' + statusKleur }}>
                  {editCursus && editCursus.id === c.id ? (
                    <div style={{ flex: 1, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: '8px', alignItems: 'end' }}>
                      <div>
                        <label style={{ fontSize: '11px', color: '#6b7280' }}>Naam</label>
                        <input type="text" value={editCursus.naam} onChange={e => setEditCursus({...editCursus, naam: e.target.value})} style={{ ...inputStyle, padding: '6px 8px' }} />
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', color: '#6b7280' }}>Behaald op</label>
                        <input type="date" value={editCursus.behaald_op ? editCursus.behaald_op.split('T')[0] : ''} onChange={e => setEditCursus({...editCursus, behaald_op: e.target.value})} style={{ ...inputStyle, padding: '6px 8px' }} />
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', color: '#6b7280' }}>Verloopt op</label>
                        <input type="date" value={editCursus.verloopt_op ? editCursus.verloopt_op.split('T')[0] : ''} onChange={e => setEditCursus({...editCursus, verloopt_op: e.target.value})} style={{ ...inputStyle, padding: '6px 8px' }} />
                      </div>
                      <div style={{ display: 'flex', gap: '4px' }}>
                        <button onClick={updateCursus} style={{ padding: '6px 10px', borderRadius: '4px', border: 'none', background: '#10b981', color: 'white', cursor: 'pointer', fontSize: '12px' }}>✓</button>
                        <button onClick={() => setEditCursus(null)} style={{ padding: '6px 10px', borderRadius: '4px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer', fontSize: '12px' }}>✕</button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: '500', color: '#111827' }}>{c.naam}</div>
                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                          {c.uitgever && c.uitgever + ' • '}
                          {c.behaald_op && 'Behaald: ' + new Date(c.behaald_op).toLocaleDateString('nl-NL')}
                          {c.certificaat_nummer && ' • Nr: ' + c.certificaat_nummer}
                        </div>
                      </div>
                      {c.verloopt_op && (
                        <span style={{ padding: '3px 10px', borderRadius: '10px', fontSize: '12px', fontWeight: '500', background: statusBg, color: statusKleur }}>
                          {statusTekst} {status !== 'geldig' ? '' : ''} - {new Date(c.verloopt_op).toLocaleDateString('nl-NL')}
                        </span>
                      )}
                      {!c.verloopt_op && <span style={{ padding: '3px 10px', borderRadius: '10px', fontSize: '12px', background: '#f0fdf4', color: '#10b981' }}>Geen vervaldatum</span>}
                      {c.document_url && (
                        <button onClick={() => downloadCursusBestand(c.id, c.naam)} style={{ padding: '4px 8px', borderRadius: '4px', border: '1px solid #bfdbfe', background: '#eff6ff', cursor: 'pointer', fontSize: '12px', color: '#2563eb' }}>📄 PDF</button>
                      )}
                      {isWerkvoorbereider && (
                        <div style={{ display: 'flex', gap: '4px' }}>
                          <button onClick={() => setEditCursus({...c})} style={{ padding: '4px 8px', borderRadius: '4px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer', fontSize: '12px' }}>✏️</button>
                          <button onClick={() => deleteCursus(c.id)} style={{ padding: '4px 8px', borderRadius: '4px', border: '1px solid #fecaca', background: '#fef2f2', cursor: 'pointer', fontSize: '12px', color: '#dc2626' }}>🗑️</button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Cursus toevoegen modal */}
      {showCursusModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }} onClick={() => setShowCursusModal(false)}>
          <div style={{ background: 'white', borderRadius: '8px', width: '100%', maxWidth: '480px' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #e5e7eb' }}>
              <h2 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>🎓 Certificaat Toevoegen</h2>
              <button onClick={() => setShowCursusModal(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#6b7280' }}>x</button>
            </div>
            <div style={{ padding: '20px', display: 'grid', gap: '12px' }}>
              <div>
                <label style={labelStyle}>Naam *</label>
                <input type="text" value={nieuweCursus.naam} onChange={e => setNieuweCursus({...nieuweCursus, naam: e.target.value})} placeholder="bijv. VCA Basis" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Uitgever</label>
                <input type="text" value={nieuweCursus.uitgever} onChange={e => setNieuweCursus({...nieuweCursus, uitgever: e.target.value})} placeholder="bijv. SSVV" style={inputStyle} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>Behaald op</label>
                  <input type="date" value={nieuweCursus.behaald_op} onChange={e => setNieuweCursus({...nieuweCursus, behaald_op: e.target.value})} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Verloopt op</label>
                  <input type="date" value={nieuweCursus.verloopt_op} onChange={e => setNieuweCursus({...nieuweCursus, verloopt_op: e.target.value})} style={inputStyle} />
              </div>
              </div>
              <div>
                <label style={labelStyle}>Certificaat nummer</label>
                <input type="text" value={nieuweCursus.certificaat_nummer} onChange={e => setNieuweCursus({...nieuweCursus, certificaat_nummer: e.target.value})} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Notities</label>
                <textarea value={nieuweCursus.notities} onChange={e => setNieuweCursus({...nieuweCursus, notities: e.target.value})} rows="2" style={{ ...inputStyle, resize: 'vertical' }} />
              </div>
              <div>
                <label style={labelStyle}>Certificaat (PDF, optioneel)</label>
                <input type="file" accept="application/pdf" onChange={e => setCursusBestand(e.target.files[0])} style={{ fontSize: '13px' }} />
              </div>
              <button onClick={addCursus} style={{ padding: '10px', borderRadius: '6px', border: 'none', background: '#3b82f6', color: 'white', cursor: 'pointer', fontWeight: '500', fontSize: '14px' }}>Toevoegen</button>
            </div>
          </div>
        </div>
      )}
      <DocumentenSectie />
    </div>
  );
};

const DocumentenSectie = () => {
  const { id } = useParams();
  const { gebruiker: huidige } = useAuth();
  const magUploaden = ['werkvoorbereider','bedrijf_admin','hoofdbeheerder','super_admin'].includes(huidige?.rol);
  const [documenten, setDocumenten] = useState([]);
  const [loading, setLoading] = useState(true);
  const [titel, setTitel] = useState('');
  const [bestand, setBestand] = useState(null);
  const [uploading, setUploading] = useState(false);

  const laad = () => {
    if (!id) return;
    const token = localStorage.getItem('token');
    fetch(`/api/gebruikers/${id}/documenten`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { if (d.success) setDocumenten(d.documenten || []); setLoading(false); })
      .catch(() => setLoading(false));
  };
  useEffect(() => { laad(); }, [id]);

  const uploadCertificaat = async () => {
    if (!bestand) { alert('Kies een PDF'); return; }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('bestand', bestand);
      if (titel.trim()) fd.append('titel', titel.trim());
      await api.post('/gebruikers/' + id + '/documenten', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setTitel(''); setBestand(null);
      laad();
    } catch (e) {
      alert('Upload mislukt: ' + (e?.response?.data?.message || e.message));
    }
    setUploading(false);
  };

  const downloadDoc = async (docId, naam) => {
    const token = localStorage.getItem('token');
    const r = await fetch(`/api/gebruikers/${id}/documenten/${docId}/download`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) return alert('Download mislukt');
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = naam; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginTop: '16px' }}>
      <h2 style={{ fontSize: '16px', fontWeight: '600', margin: '0 0 16px 0' }}>📁 Documenten</h2>
      {magUploaden && (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', padding: '12px', background: '#f9fafb', borderRadius: '8px' }}>
          <input type="text" value={titel} onChange={e => setTitel(e.target.value)} placeholder="Titel (bijv. VCA Basis)" style={{ flex: '1 1 200px', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px' }} />
          <input type="file" accept="application/pdf" onChange={e => setBestand(e.target.files[0])} style={{ fontSize: '13px' }} />
          <button onClick={uploadCertificaat} disabled={uploading || !bestand} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: (uploading || !bestand) ? '#9ca3af' : '#3b82f6', color: 'white', cursor: (uploading || !bestand) ? 'default' : 'pointer', fontSize: '13px', fontWeight: '500' }}>{uploading ? '⏳ Uploaden...' : '📄 Certificaat uploaden'}</button>
        </div>
      )}
      {loading ? (
        <p style={{ color: '#6b7280', textAlign: 'center', padding: '20px' }}>Laden...</p>
      ) : documenten.length === 0 ? (
        <p style={{ color: '#6b7280', textAlign: 'center', padding: '20px' }}>Nog geen documenten</p>
      ) : (
        <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #e5e7eb', textAlign: 'left' }}>
              <th style={{ padding: '8px' }}>Titel</th>
              <th style={{ padding: '8px' }}>Type</th>
              <th style={{ padding: '8px' }}>Datum</th>
              <th style={{ padding: '8px' }}></th>
            </tr>
          </thead>
          <tbody>
            {documenten.map(d => (
              <tr key={d.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                <td style={{ padding: '8px' }}>{d.titel || d.bestandsnaam}</td>
                <td style={{ padding: '8px', color: '#6b7280' }}>{d.bron_type}</td>
                <td style={{ padding: '8px', color: '#6b7280' }}>{new Date(d.created_at).toLocaleDateString('nl-NL')}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>
                  <button onClick={() => downloadDoc(d.id, d.bestandsnaam)} style={{ padding: '4px 12px', borderRadius: '4px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer', fontSize: '13px' }}>📥 Download</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MonteurProfiel;

